@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Simulations in progress</h1>

<div class="grid">
  <div class="cell">
    <app-simulations-info
      [title]="`All simulations (${allSimulations().length})`"
      [currentUserEmail]="currentUser?.email ?? ''"
      [runningSimulations]="allSimulations"
      (simulationAction)="onSimulationAction($event)"
    >
    </app-simulations-info>
  </div>
  <div class="cell">
    <app-simulations-info
      [title]="`My simulations (${filteredSimulations().length})`"
      [currentUserEmail]="currentUser?.email ?? ''"
      [runningSimulations]="filteredSimulations"
      (simulationAction)="onSimulationAction($event)"
    >
    </app-simulations-info>
  </div>
</div>
